import { App } from './App'
import React, { useEffect } from 'react'
import ReactDOM from "react-dom/client";
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { CssBaseline } from '@mui/material'
import { create } from 'jss'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { StylesProvider, jssPreset } from '@mui/styles'
import store from './app/store'

/** MOMENT LOCALE */
import 'moment/locale/en-gb'
import 'moment/locale/th'

/** STYLES */
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css'

import './index.css'
import './styles/input.css'
import './styles/switch.css'
import './styles/print.css'
import './styles/custom.css'
import './styles/dataTable.css'
import './styles/datePicker.css'
import './styles/ckEditor.css'
import './App.css'

const jss = create({
  ...jssPreset()
})

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 576,
      sm: 768,
      md: 1000,
      lg: 1360,
      xl: 1920
    }
  },
  zIndex: {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 2050,
    snackbar: 1400,
    tooltip: 1500
  }
})

// const theme = unstable_createMuiStrictModeTheme()
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <ThemeProvider theme={theme}>
    <StylesProvider jss={jss}>
      <CssBaseline />
      <Provider store={store}>
        {/* <head> */}
        <noscript id="jss-insertion-point" />
        {/* </head> */}
        <App />
      </Provider>
    </StylesProvider>
  </ThemeProvider>
)
// function Main() {
//   return (

//   )
// }

// ReactDOM.render(<Main />, document.getElementById('root'))
// const container = document.getElementById('app')
// const root = createRoot(container!) // createRoot(container!) if you use TypeScript
// root.render(<Main />)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
